(function (app, ng) {

    app.directive("hideIfOne", ["permissionService", "$compile", function (permissionService, $compile) {
        return {
            //High priority means it will execute first
            priority: 4000,
            //Terminal prevents compilation of any other directive on first pass
            terminal: true,
            compile: function (element, attr) {
              
                if (permissionService.hasOnePermission(attr.hideIfOne, true)) {
                    //Add ng-if to the dom
                    attr.$set("ng-if", false);
                }

                //Now that we added ng-if to the element, proceed with compilation
                //but skip directives with priority 5000 or above to avoid infinite 
                //recursion (we don't want to compile ourselves again)
                var compiled = $compile(element, null, 4000);
                return function (scope) {
                    //When linking just delegate to the link function returned by the new 
                    //compile
                    compiled(scope);
                }
            }
        }
    }]);

})(window.app, window.angular); //jshint ignore:line